// extracted by mini-css-extract-plugin
export const divider = "Divider-module--divider--2q3Wp";
export const line = "Divider-module--line--5C2Zd";
export const content = "Divider-module--content--2Gj9t";